/******************************************************************************
 *** BgtMbsdsEvdncList ** 운영비 지출증빙내역서 목록
*******************************************************************************/
import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import Button from "@/js/common/ui/Button";
import Util from "@/js/common/Util";
import React from "react";

interface Props {
    doSave: (newValue: string) => void; // 지출결의서 저장
    mbsdsExpndDocId       : string  ; // 운영비 지출결의서 문서 ID
    setMbsdsEvdncModalOpen: Function; // 증빙 상세 모달 오픈
    setExpndEvdncId       : Function; // 증빙 문서 ID Setting
    setMbsdsEvdncYn       : Function; // 증빙 유무
    setImplAmt            : Function; // 지출결의서 금액 설정
    mbsdsEvdncDelYn       : string  ; // 지출증빙내역서 삭제 여부
    callTime              : Date;
}

const BgtMbsdsEvdncList = ( {doSave, mbsdsExpndDocId, setMbsdsEvdncModalOpen, setExpndEvdncId, setMbsdsEvdncYn, setImplAmt, mbsdsEvdncDelYn, callTime}: Props ) => {
    const [evdncdataArr, setEvdncDataArr] = React.useState<any[]>([]);
    const [sumUseAmt   , setSumUseAmt   ] = React.useState<string>("0"); // 지출증빙 사용금액 합계
    const [hoveredRow  , setHoveredRow  ] = React.useState<number | null>(null); // 마우스 오버 색상변경

    // 특별회계기금 지출증빙내역서 목록 조회
    React.useEffect(() => {
        AppContext.showSpinner();
        Axios.dataAccess({
            url: "system/bgt/mbsds/expnd/select-bgt-evdnc-list.do",
            methodType: "post",
            paramType: "json",
            paramData: {
                mbsdsExpndDocId: mbsdsExpndDocId // 지출결의서 문서 ID
            },
            onSuccessFn: (res: any) => {
                setEvdncDataArr(res.result.list);
                setSumUseAmt(res.result.listSum.sumUseAmt); // 지출증빙내역서 사용금액 합계
                // 지출증빙내역서 유무 확인
                if (res.result.list.length > 0) {
                    setMbsdsEvdncYn("Y");
                    setImplAmt(res.result.listSum.sumUseAmt); // 지출결의서 집행금액 셋팅
                } else {
                    setMbsdsEvdncYn("N");
                    if (mbsdsEvdncDelYn === "Y") {    // 지출증빙내역서를 모두 삭제한 경우 집행금액 Zeor로 셋팅
                        setImplAmt("0");
                    }
                }
                AppContext.hideSpinner();
            },
        });
    }, [mbsdsExpndDocId, setSumUseAmt, setMbsdsEvdncYn, setImplAmt, mbsdsEvdncDelYn, callTime]);

    return (
        <div className="mb10 pt5">
            <div className="h30 dpFlx jcSb aiE pb5">
                <span className="fm-b fs13 ls06 fc111111 mb5">지출 증빙 내역</span>
                {/* 지출증빙내역서 등록 버튼 */}
                <Button buttonName="지출 증빙내역서 등록"
                    width={140} height={30}
                    fontFamily="fm-c" fontSize={13} letterSpacing={-0.3} color="#fff"
                    backgroundColor="#4A90E2" borderRadius={4}
                    buttonClass="dpFlx aiC jcC bd1 bdc007bff"
                    onClickFunc={() => {
                        doSave("00");
                    }}
                />
            </div>
            <div className="w100p ofxA">
                <div style={{ minWidth: 320 }}>
                    <div className="bd1 bdcDDDDDD bdrd2 bgcWhite">
                        <table style={{borderCollapse: "collapse", width: "100%"}}>
                            <colgroup>
                                <col className="w100"></col>
                                <col className="w120"></col>
                                <col className="w100"></col>
                            </colgroup>
                            <thead>
                                <tr className="bgcf0f8ff h30" style={{borderBottom: "1px solid #ccc"}}>
                                    <th className="fm-a fs12 fc555555">사용일자</th>
                                    <th className="fm-a fs12 fc555555">사용목적</th>
                                    <th className="fm-a fs12 fc555555">금액</th>
                                </tr>
                            </thead>
                            <tbody>
                            {evdncdataArr.length === 0 && (
                                    <tr style={{borderBottom: "1px solid #ccc"}}>
                                        <td colSpan={3} className="h28 taC fm-c fs12 fc999999">조회된 지출증빙내역서가 없습니다.</td>
                                    </tr>
                            )}
                            {evdncdataArr.map((row, index) => (
                                <tr key={index} className="csP" onMouseOver={() => setHoveredRow(index)} onMouseOut={() => setHoveredRow(null)}
                                    style={{
                                    borderBottom: "1px solid #ccc",
                                    backgroundColor: hoveredRow === index ? "#EDF2FD" : "white"
                                }} onClick={() => {
                                    setMbsdsEvdncModalOpen(true);
                                    setExpndEvdncId(row.expndEvdncId); // 지출증빙내역서 ID
                                }}>
                                    <td className="h28 taC fm-c fs12 fc828282">{Util.cvtDateStrForm(row.useDt, '-')}</td>
                                    <td className="h28 taL fm-c fs12 fc828282"><span className="dpInBlock ellipsis w120">{row.usePrpsCn}</span></td>
                                    <td className="h28 taC fm-c fs12 fc828282 taR pr5">{Util.comma(row.useAmt)}</td>
                                </tr>
                            ))}
                            </tbody>
                            <tfoot>
                                <tr className="h28 bgcDCDCDC">
                                    <td colSpan={2} className="fm-b fs13 ls06 taC">합계</td>
                                    <td className="taR fm-c fs13 ls06 pr5">{Util.comma(sumUseAmt)}</td>
                                </tr>
                            </tfoot>
                        </table>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default BgtMbsdsEvdncList;